import styled from 'styled-components';

const MobileContainer = styled('div')`
  @media (min-width: ${(props) => props.theme.breakpoints.lg}) {
    display: none;
  }
`;

export default MobileContainer;
